import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Button,
  FormFieldSet,
  TableAdv,
  useFormHandler,
} from "../../../../components";
import { upcommingpayfrequency } from "../../../../assets/data/projectData";
import { usePagination } from "../../../../hooks";

const OffCyclePayData = () => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    selectPayFrequency: "",
    payProfile: "",
  });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const tableData = [];
  const columns = [
    {
      key: "offCycleName",
      label: "Off-Cycle Name",
    },

    {
      key: "payDate",
      label: "Pay Date",
    },
    {
      key: "type",
      label: "Type",
    },
    {
      key: "linkedEmployees",
      label: "Linked Employees",
    },
    {
      key: "proposed",
      label: "Proposed",
    },
    {
      key: "finalized",
      label: "Finalized",
    },
    {
      key: "paid",
      label: "Paid",
    },
    {
      key: "totalPayout",
      label: "Total Payout",
    },
    {
      key: "lastUpdated",
      label: "Last Updated",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-1 cursor-pointer text-linkblue ">
          <Button
            type="icon"
            variant="text"
            icon={"arrow_back_2"}
            color="black"
            size="sm"
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <TableAdv
        tableId="payroll_offcyclepaydata"
        rows={mappedRows}
        columns={columns}
        totalCount={tableData?.length}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          add: [
            {
              component: (
                <div className="flex gap-2 mt-2 mb-2 ">
                  <FormFieldSet
                    type="text"
                    title=""
                    size="sm" // this has no effect, bug?
                    placeholder="Pay Profile"
                    value={formData.payProfile || ""}
                    onChange={(value) => handleChange("payProfile", value)}
                    error={errors.payProfile}
                  />
                  <FormFieldSet
                    type="select"
                    size="sm"
                    title="Select Pay Frequency"
                    placeholder="Select Pay Frequency"
                    value={formData.selectPayFrequency || ""}
                    onChange={(value) =>
                      handleChange("selectPayFrequency", value)
                    }
                    error={errors.selectPayFrequency}
                    options={upcommingpayfrequency}
                  />
                  <div className="mt-5">
                    <Button size="sm" title={"Search"} onClick={""} />
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default OffCyclePayData;
